import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {TogglePlay} from '../../store/player.actions';
import {PlayerState} from '../../store/player.state';

@Component({
  selector: 'gg-big-play-btn',
  templateUrl: './big-play-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BigPlayBtnComponent implements OnInit {
  public isPlaying$ = this.store.select(state => state.player.isPlaying);

  constructor(private store: Store) {
  }

  ngOnInit() {

  }

  btnClick() {
    this.store.dispatch(new TogglePlay());
  }

}
